export default {
  general: {
    Start: "Comenzar",
    Back: "Volver",
    Next: "Siguiente",
    Cancel: "Cancelar",
    Skip: "Omitir",
    Preview: "Vista previa",
    Email: "Introduce tu correo electrónico",
    EmailHint: "Correo electrónico",
    Phone: "Introduce tu número de teléfono",
    PhoneHint: "Número de teléfono",
    Password: "Introduce tu contraseña",
    PasswordHint: "Contraseña",
    PasswordReenter: "Introduce tu contraseña de nuevo",
    CreatePasswordTitle: "Crea una contraseña para asegurar tu cuenta y garantizar un acceso seguro.",
    CreatePasswordCheck: "Debe tener al menos {1}8 caracteres{2}, incluir {3}letras{4} minúsculas y {5}mayúsculas{6}, {7}un número{8} y {9}un carácter especial{10}.",
    CreatePasswordMustMatch: "La contraseña debe coincidir.",
    CreateNewPassword: "Crea una nueva contraseña",
    Setup: "Configuración",
    Create: "Crear",
    RememberMe: "Recuérdame",
    ForgotPassword: "¿Olvidaste tu contraseña?",
    Login: "Iniciar sesión",
    Logout: "Cerrar sesión",
    CloseAccount: "Cerrar cuenta",
    CloseAccountAsk: "¿Estás seguro de que quieres cerrar la cuenta?",
    Yes: "Sí",
    No: "No",
    or: "o",
    Add: "Agregar",
    DontHaveAccount: "¿No tienes cuenta?",
    Register: "Registrarse",
    Verify: "Verificar",
    Send: "Enviar",
    TryAgain: "Intentar de nuevo",
    EnterName: "Introduce tu nombre",
    EnterNameHint: "Nombre",
    EnterSurname: "Introduce tu apellido",
    EnterSurnameHint: "Apellido",
    Connecting: "Conectando...",
    Search: "Buscar",
    Generate: "Generar",
    Finish: "Finalizar",
    Save: "Guardar",
    SaveInProgres: "Guardado en progreso..."
  },

  bottomPanel: {
    Profile: "Perfil",
    Tasks: "Tareas",
    Host: "Anfitrión",
    Messages: "Mensajes",
    Alerts: "Alertas"
  },

  login: {
    VerificationTitleEmail: "Introduce el código de verificación enviado a tu correo electrónico.",
    VerificationTitlePhone: "Introduce el código de verificación enviado a tu teléfono.",
    HaventReceivedCode: "¿No has recibido el correo electrónico?",
    CodeSendPhone: "El código de verificación ha sido enviado a tu teléfono.",
    CodeSendEmail: "El código de verificación ha sido enviado a tu correo electrónico.",
    CodeSendFailed: "No se ha podido enviar el código de verificación.",
    CodeSendDisabled: "Por favor, espera {1} segundos antes de volver a solicitar el código de verificación.",
    CodeWrong: "Código incorrecto, ¡inténtalo de nuevo!",
    EnterFullName: "Por favor, introduce tu nombre completo para completar tu perfil.",
    AgreeTo: "Acepto",
    TermsConditions: "Términos y condiciones",
    PasswordResetTitle: "Por favor, introduce la dirección de correo electrónico a la que se enviará el enlace para restablecer la contraseña.",
    PosswordResetSend: "La instrucción para restablecer la contraseña ha sido enviada al correo electrónico indicado.",
    PasswordResetNew: "La nueva contraseña ha sido establecida.",
    CantCreateAccount: "No se pudo crear la cuenta. Por favor, inténtalo de nuevo más tarde.",
    CantLogin: "No se puede iniciar sesión, credenciales incorrectas.",
    LoginDeactivated: "No se puede iniciar sesión, tu cuenta está cerrada. Por favor, contacta con el soporte para reactivar tu cuenta.",
    PropertiesTitle: "Propiedades",
    PropertiesDescription: "Una forma rápida, conveniente y transparente de mostrar tu propiedad y atraer a los clientes adecuados.",
    GuestsTitle: "Invitados",
    GuestsDescription: "Tu base de datos completa de invitados, que te permite acceder fácilmente a los contactos anteriores. Ponte en contacto fácilmente e invítalos de nuevo, con todo el historial de comunicación y actividad en un solo lugar.",
    OffersTitle: "Ofertas",
    OffersDesctiption: "Mantente al tanto de todas las ofertas de alquiler enviadas, recibe recordatorios automáticos para que no se pase por alto nada, y dirige tu oferta hacia una reserva exitosa.",
    ReservationsTitle: "Reservas",
    ReservationsDescription: "Una forma clara e intuitiva de gestionar las reservas. Sabes exactamente cuándo te visitan los invitados, con recordatorios de tareas para ofrecer un servicio de la más alta calidad.",
    MarketingTitle: "Marketing",
    MarketingDescription: "Una herramienta eficiente para crear contenido de marketing atractivo en Facebook e Instagram, basada en inteligencia artificial.",
    FinanceTitle: "Finanzas",
    FinanceDescription: "Una visión sencilla y fácil de usar de las finanzas de tu propiedad, que incluye el retorno de la inversión y los pagos de los clientes, todo en un solo lugar.",
    StatisticsTitle: "Estadísticas",
    StatisticsDescription: "Una visión rápida de los indicadores clave relacionados con tu propiedad que te ayudará a hacer un seguimiento de los resultados, y con la ayuda de la inteligencia artificial recibirás sugerencias sobre en qué centrarte a continuación."
  },

  termsConditions: {
    title: "Términos y condiciones",
    introduction: "¡Bienvenido a nuestro sitio web! Al acceder a nuestros servicios, aceptas cumplir con los siguientes términos y condiciones.",
    useOfWebsite: "Aceptas usar este sitio web solo para fines legales. No debes usar este sitio web de una manera que pueda dañar, desactivar o afectar la funcionalidad del mismo.",
    accountRegistration: "Cuando crees una cuenta en nuestro sitio web, eres responsable de mantener la confidencialidad de tus credenciales de acceso y de todas las actividades que ocurran bajo tu cuenta.",
    intellectualProperty: "Todo el contenido de este sitio web, incluidos textos, gráficos y logotipos, es propiedad del propietario del sitio web y está protegido por las leyes de derechos de autor.",
    privacyPolicy: "Tu privacidad es importante para nosotros. Por favor, lee nuestra política de privacidad para saber cómo procesamos tus datos personales.",
    limitationOfLiability: "No nos hacemos responsables de los daños o pérdidas resultantes del uso del sitio web. Usas el sitio web bajo tu propio riesgo.",
    modifications: "Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones se publicarán en esta página y es tu responsabilidad revisarlas regularmente.",
    governingLaw: "Estos términos y condiciones se rigen por la legislación de la jurisdicción en la que se encuentra el propietario del sitio web. Cualquier disputa será resuelta en los tribunales competentes de dicha jurisdicción.",
    contactUs: "Si tienes alguna pregunta o inquietud acerca de estos términos y condiciones, por favor, contáctanos."
  },

  host: {
    Properties: "Propiedades",
    PropertyDescribe: "Describe la propiedad",
    Guests: "Huéspedes",
    GuestAdd: "Agregar huésped",
    Places: "Lugares",
    PlaceDescribe: "Describe el lugar",
    PlaceAI: "Introduce algunos detalles sobre el lugar que deseas agregar para generarlo automáticamente.",
    Attractions: "Atracciones",
    AttractionDescribe: "Describe la atracción",
    AttractionAI: "Introduce los detalles de la atracción que deseas agregar para generarla automáticamente.",
    Dishes: "Platos",
    DisheDescribe: "Describe el plato",
    Restaurants: "Restaurantes",
    RestaurantDescribe: "Describe el restaurante",
    Offers: "Ofertas",
    OfferAdd: "Agregar oferta",
    Reservations: "Reservas",
    ReservationAdd: "Agregar reserva",
    Marketing: "Marketing",
    Statistics: "Estadísticas",
    Finance: "Finanzas",
    Calendar: "Calendario",
    Overview: "Vista general",
    Gallery: "Galería",
    AttractionOverview: "Resumen de atracciones",
    PlaceOverview: "Resumen del lugar",
    DishOverview: "Resumen del plato",
    RestaurantOverview: "Resumen del restaurante",
    AddFailed: "Se produjo un error al agregar.",
    UpdateFailed: "Ocurrió un error al guardar.",
    AddOk: "Añadido correctamente.",
    UpdateOk: "Guardado correctamente.",
    UniqueIdExists: "El ID único ya ha sido utilizado, seleccione otro.",
    ListEmpty: "La lista está vacía, agrega el primer elemento.",
    ListCantLoadItem: "¡No se puede cargar el elemento!",
    ListCancelAsk: "¿Estás seguro de que quieres perder los cambios realizados?",
    DeleteItemAsk: "¿Realmente quieres eliminar este elemento?",
    DeleteItemOk: "Elemento eliminado.",
    DeleteItemFailed: "¡No se puede eliminar el elemento!"
  },

  edit: {
    Name: "Nombre",
    NameHint: "Introduce el nombre",
    Slogan: "Eslogan",
    SloganHint: "Introduce el eslogan",
    PhotoAdd: "Añadir fotos",
    PhotoSelect: "La galería está vacía",
    PhotoChangeOrder: "Mantén presionadas y mueve las fotos para organizar el orden. La primera foto será la miniatura.",
    Description: "Descripción",
    DescriptionAdd: "Añadir descripción",
    AttractionsAdd: "Añadir atracciones",
    RestaurantsAdd: "Añadir restaurantes",
    FactsAdd: "Añadir datos interesantes",
    DetailsAdd: "Añadir detalles",
    DishesAdd: "Añadir platos",
    VisitTime: "Hora de la visita",
    VisitTimeHint: "Introduce la hora de la visita",
    TicketsBuy: "Dónde comprar boletos",
    TicketsBuyHint: "Introduce dónde comprar boletos",
    Website: "Sitio web",
    WebsiteHint: "Introduce el sitio web",
    Place: "Lugar",
    PlaceHint: "Selecciona un lugar",
    Address: "Dirección",
    AddressHint: "Introduce la dirección",
    MoreInformations: "Más información",
    MoreInformationsHint: "Introduce más información",
    UniqueId: "ID única",
    UniqueIdHint: "Introduce una ID única (a-z 0-9 _)"
  },

  language: {
    Polish: "Polaco",
    English: "Inglés",
    German: "Alemán",
    Spanish: "Español",
    AITranslate: "Traducción de IA"
  },

  ai: {
    translationNotAvailable: "La traducción AI no está disponible en este momento.",
    serviceNotAvailable: "El servicio de IA no está disponible."
  },

  addressPopup: {
    copyAddress: "📋 Copiar dirección",
    copyGPS: "📍 Copiar coordenadas GPS",
    openMaps: "🗺 Abrir en mapas"
  },

  state: {
    placeNew: "Nuevo",
    placeInPreparation: "En preparación",
    placePublished: "Publicado"
  },

  waitingList: {
    Sign: "Regístrate",
    AlreadyExists: "Ya estás en la lista de espera.",
    Added: "¡Has sido agregado a la lista de espera, gracias por tu interés en nuestra aplicación!",
    Title: "Regístrate en la lista de espera",
    Agreement: "Al registrarte, aceptas recibir información sobre la aplicación Flatlinker en la dirección de correo electrónico proporcionada. Puedes darte de baja de la información recibida enviando un correo a newsletter@flatlinker.com con el contenido: Darse de baja de la lista."
  }
};